var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCopyIcon = function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1 6a1 1 0 01.993.883L2 7v7h7a1 1 0 01.993.883L10 15a1 1 0 01-.883.993L9 16H1a1 1 0 01-.993-.883L0 15V7a1 1 0 011-1zm12-5a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V3a2 2 0 012-2zm0 2H5v8h8V3z",
    id: "CopyIcon_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#CopyIcon_svg__a",
    transform: "translate(0 -1)"
  })));
};
export default SvgCopyIcon;